import EditIcon from '@mui/icons-material/Edit';
import { Badge, Box, Button, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Fab, FormControlLabel, FormLabel, Grid, IconButton, Stack, Typography } from "@mui/material";
import { ChangeEvent, useState } from "react";
import { Setter } from "../_/utils/ReactUtils";
import { feats } from "../content/feats";
import { CharacterStats, Stats } from "./Stats";
import { SkillDef, SkillID, skillCategories, rawSkills, skillsMap } from '../content/skills';
import { locale } from '../content/locale';

export const Skills = ({ stats, setStats }: { stats: CharacterStats, setStats: Stats }) => {

    const [open, setOpen] = useState<boolean>(false);

    return (
        <Stack direction={"column"}
            justifyContent="space-between"
            sx={{ height: '100%' }}>
            {locale.skills.capitalize()}
            <Grid spacing={3}  >
                {stats.skills.map(skillId => {
                    const skill  = skillsMap.get(skillId)!
                    return <Skill2  skill={ skill} />
                }
                )}

            </Grid>
            <Box display="flex" justifyContent="flex-end">
                <IconButton size="small" onClick={() => setOpen(true)} sx={{ width: "auto", height: "100%" }} >
                    <EditIcon fontSize={"small"} />
                </IconButton>
            </Box>

            <SkillsDialog open={open} setOpen={setOpen} stats={stats} setStats={setStats} />
        </Stack>

    )
}

const SkillsDialog = ({ open, setOpen, stats, setStats }: { open: boolean, setOpen: Setter<boolean>, stats: CharacterStats, setStats: Stats }) => {

    const handleClose = () => {
        setOpen(false);
    };



    return (
        <Dialog
            open={open}
            onClose={handleClose}
        >
            <DialogTitle>Zdolności</DialogTitle>
            <DialogContent>
                <DialogContentText>

                </DialogContentText>

                <Box
                    noValidate
                    component="form"
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        m: 'auto',
                        width: 'fit-content',
                    }}
                >
                    <Grid>
                        {Object.entries(skillCategories).map(([category, skills]) =>
                            <>
                                {skills.map(skill => <Skill stats={stats} setStats={setStats} skill={skill} kind={category} />)}

                            </>)}
                    </Grid>

                </Box>
            </DialogContent>

            <DialogActions>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Typography>Dostepne punkty: {stats.freeSkills}</Typography>
                    <Button onClick={handleClose}>Close</Button>
                </Box>
            </DialogActions>
        </Dialog>
    )
}

const Skill = ({ skill, kind, stats, setStats }: { skill: SkillDef, kind: string, stats: CharacterStats, setStats: Stats }) => {
    const [checked, setChecked] = useState(true);

    // const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     setChecked(event.target.checked);
    // };

    const handleChange = (event: ChangeEvent<HTMLInputElement>, skill: SkillID) => {
        if (event.target.checked)
            setStats.setSkill(skill)
        else
            setStats.unsetSkill(skill)
    }
    const isDisabled = (skill: SkillID) => {
        // return stats.freeSkills < skillsMap.get(skill)!.level
        return false
    }

    return (
        <Box >
            <Stack spacing={1} direction="row" >
                <FormControlLabel
                    control={
                        <Checkbox checked={stats.skills.includes(skill.id)} disabled={isDisabled(skill.id)} onChange={e => handleChange(e, skill.id)} name="gilad" />
                    }
                    label={skill.name}

                />
                <Box
                    sx={{
                        '&.disabled-container > *': {
                            pointerEvents: 'none',
                            opacity: 0.5,
                        },
                    }}
                    className={isDisabled(skill.id) ? 'disabled-container' : ''}
                >
                    <Typography variant='body2' gutterBottom marginBottom={"14px"} align="justify">
                        Koszt: skill.level
                    </Typography>
                </Box>
            </Stack>
            <Box
                sx={{
                    '&.disabled-container > *': {
                        pointerEvents: 'none',
                        opacity: 0.5,
                    },
                }}
                className={isDisabled(skill.id) ? 'disabled-container' : ''}
            >
                <Typography variant='body2' gutterBottom marginBottom={"14px"} align="justify">
                    {skill.description}
                </Typography>
            </Box>
        </Box > 
    )
}

    const Skill2 = ({ skill}: { skill: SkillDef }) => {

        return (
            <Box >
                <Typography variant='subtitle1' align="justify">
                    {skill.name}
                </Typography>
                <Typography variant='body2' gutterBottom marginBottom={"10px"} align="justify">
                    {skill.description}
                </Typography>
            </Box >
        )
    }